import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-team-spacer" }
const _hoisted_2 = { class: "small-text" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "small-text team-prefix m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputElement = _resolveComponent("InputElement")!
  const _component_ButtonElement = _resolveComponent("ButtonElement")!
  const _component_ModalLayout = _resolveComponent("ModalLayout")!

  return (_openBlock(), _createBlock(_component_ModalLayout, { "has-close-button": true }, {
    footer: _withCtx(() => [
      _createVNode(_component_ButtonElement, {
        theme: "primary",
        size: "sm",
        type: "button",
        loading: _ctx.loading,
        disabled: _ctx.isCreateButtonDisabled,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doCreateTeam(_ctx.teamName)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('modals.team.buttons.create')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('modals.team.team_name')), 1),
        _createElementVNode("form", {
          class: "team-name-form",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.doCreateTeam(_ctx.teamName)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('modals.team.team')), 1),
            _createVNode(_component_InputElement, {
              class: "w-100",
              errors: _ctx.error,
              modelValue: _ctx.teamName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.teamName) = $event)),
              placeholder: _ctx.$t('modals.team.team_name_placeholder')
            }, null, 8, ["errors", "modelValue", "placeholder"])
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}